const cookieBannerStrings = {
    body: "Para asegurarnos de que tengas la mejor experiencia posible mientras nos visitas, usamos cookies y tecnologías similares.",
    accept: "Aceptar",
    decline: "Rechazar",
};

export default cookieBannerStrings;
